import { render, staticRenderFns } from "./browscolForm.vue?vue&type=template&id=764124ba&scoped=true"
import script from "./browscolForm.vue?vue&type=script&lang=js"
export * from "./browscolForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764124ba",
  null
  
)

export default component.exports